import { makeStyles } from "@material-ui/core/styles";
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme";
import { Badge } from "App/Component/ui";

export const STYLE_JADWAL_KONSULTASI = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
  buttonBack: {
    background: "none",
    border: "none",
    display: "flex",
    gap: "20px",
    fontSize: "14px",
    cursor: "pointer",
  },
  title: {
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "12px",
    color: "#BDBDBD",
  },
  assesmentTitle: {
    fontWeight: 600,
    color: "#828282",
    fontSize: "16px",
  },
  assesmentList: {
    listStyle: "none",
  },
});

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "asssesment",
    disablePadding: true,
    label: "ASSESMENT PASIEN",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID TRANSAKSI",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "day",
    disablePadding: false,
    label: "HARI",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "date",
    disablePadding: false,
    label: "TANGGAL",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "time",
    disablePadding: false,
    label: "JAM",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "name_rm",
    disablePadding: false,
    label: "NAMA RM",
    align: "left",
    minWidth: "150px",
  },
];

export const StatusKonsultasi = ({ status }) => {
  if (status === "selesai") {
    return (
      <Badge
        color='green'
        label='Selesai'
        style={{
          padding: "0.3rem 1rem",
          fontSize: "12px",
        }}
      />
    );
  } else if (status === "expired") {
    return (
      <Badge
        color='black'
        label='Expired'
        style={{
          padding: "0.3rem 1rem",
          fontSize: "12px",
        }}
      />
    );
  } else if (status === "batal") {
    return (
      <Badge
        color='danger'
        label='Batal'
        style={{
          padding: "0.3rem 1rem",
          fontSize: "12px",
        }}
      />
    );
  } else if (status === "jadwal ulang") {
    return (
      <Badge
        color='warning'
        label='Jadwal Ulang'
        style={{
          padding: "0.3rem 1rem",
          fontSize: "12px",
        }}
      />
    );
  }
};

export const dataDummy = [
  {
    id: "1",
    day: "Selasa",
    date: "2021-09-22",
    time: "09:00 - 10:00",
    name_rm: "Agung Hapsah",
    status: "selesai",
  },
  {
    id: "2",
    day: "Rabu",
    date: "2021-09-22",
    time: "09:00 - 10:00",
    name_rm: "Agung Hermanto",
    status: "expired",
  },
  {
    id: "3",
    day: "Rabu",
    date: "2021-09-22",
    time: "09:00 - 10:00",
    name_rm: "Agus Herman",
    status: "jadwal ulang",
  },
  {
    id: "4",
    day: "Rabu",
    date: "2021-09-22",
    time: "09:00 - 10:00",
    name_rm: "Aku gatau siapa",
    status: "batal",
  },
];
